<template>
  <div class="container mt-5">
    <h2 class="text-center mb-4">개인정보 처리방침</h2>

    <div class="mb-4">
      <h3>제1조 (목적)</h3>
      <p>
        [김프모아] (이하 "회사")는 이용자의 개인정보를 보호하고 관련 법령을 준수하기 위해 본 개인정보 처리방침을 마련하였습니다. 본 웹사이트는 회원가입을 받지 않으며, 이용자의 개인정보를 직접 수집하지 않습니다. 다만, 웹사이트 운영 및 서비스 제공을 위해 자동으로 수집되는 정보가 있을 수 있으며, 이에 대한 보호 조치를 본 방침에 따릅니다.
      </p>
    </div>

    <div class="mb-4">
      <h3>제2조 (수집하는 개인정보 및 수집 방법)</h3>
      <p>
        회사는 원칙적으로 이용자의 개인정보를 직접 수집하지 않습니다. 다만, 웹사이트 운영 및 광고 서비스 제공을 위해 아래와 같은 정보가 자동으로 수집될 수 있습니다:
      </p>
      <ul>
        <li>방문 기록 (IP 주소, 접속 일시, 방문 페이지)</li>
        <li>쿠키 및 웹사이트 이용 기록</li>
        <li>브라우저 및 기기 정보 (운영체제, 브라우저 종류 및 버전 등)</li>
        <li>사용자의 광고 상호작용 데이터</li>
      </ul>
    </div>

    <div class="mb-4">
      <h3>제3조 (개인정보의 이용 목적)</h3>
      <p>
        회사는 자동 수집된 정보를 아래의 목적으로만 활용합니다:
      </p>
      <ul>
        <li>웹사이트 서비스 개선 및 운영 최적화</li>
        <li>웹사이트 보안 유지 및 악성 이용 방지</li>
        <li>접속 통계 분석 및 트래픽 관리 (Google Analytics 활용)</li>
        <li>개인 맞춤형 광고 제공 (Google AdSense 활용)</li>
      </ul>
    </div>

    <div class="mb-4">
      <h3>제4조 (개인정보의 보관 및 파기)</h3>
      <p>
        회사는 개인정보를 직접 저장하지 않으며, 자동 수집된 정보는 일정 기간 동안 보관된 후 파기됩니다. 수집된 정보는 법령에 따른 보관 기간이 지난 후 즉시 삭제되며, 복구할 수 없는 방식으로 파기됩니다.
      </p>
    </div>

    <div class="mb-4">
      <h3>제5조 (쿠키 사용 및 관리)</h3>
      <p>
        회사는 이용자의 웹사이트 방문 기록을 저장하고 관리하기 위해 <strong>쿠키(cookie)</strong>를 사용할 수 있습니다. 구글 애드센스 및 구글 애널리틱스는 쿠키를 활용하여 맞춤형 광고 및 웹사이트 분석 서비스를 제공합니다. 이용자는 웹 브라우저 설정을 통해 쿠키 저장을 거부하거나 삭제할 수 있습니다.
      </p>
      <p><strong>쿠키 설정 변경 방법 (예시)</strong></p>
      <ul>
        <li>Chrome: 설정 &gt; 개인정보 및 보안 &gt; 쿠키 및 기타 사이트 데이터</li>
        <li>Edge: 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리</li>
        <li>Firefox: 설정 &gt; 개인정보 및 보안 &gt; 쿠키 및 사이트 데이터</li>
      </ul>
    </div>

    <div class="mb-4">
      <h3>제6조 (제3자 제공 및 위탁 처리)</h3>
      <p>
        회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않으나, 아래와 같은 경우에 한해 제3자에게 제공될 수 있습니다:
      </p>
      <p><strong>제공받는 자</strong>: Google LLC (Google AdSense, Google Analytics)</p>
      <p><strong>제공 목적</strong>: 맞춤형 광고 제공 및 웹사이트 분석</p>
      <p><strong>제공 정보</strong>: IP 주소, 쿠키 정보, 방문 기록, 광고 클릭 정보 등</p>
      <p><strong>보유 및 이용 기간</strong>: 구글의 개인정보처리방침에 따름 </p>
      <p>
        구글 애드센스(Google AdSense)를 통한 광고 서비스 이용 시, 구글 및 그 파트너사는 사용자의 쿠키 정보를 기반으로 맞춤형 광고를 제공할 수 있습니다. 구글 애널리틱스(Google Analytics)는 웹사이트 방문자 통계를 분석하며, 이용자는 Google Analytics와 관련된 개인정보 처리 방침을 따릅니다.
      </p>
    </div>

    <div class="mb-4">
      <h3>제7조 (개인정보의 안전성 확보 조치)</h3>
      <p>
        회사는 이용자의 개인정보를 안전하게 보호하기 위해 기술적, 관리적 조치를 취하고 있습니다. 개인정보를 처리하는 시스템에 대한 접근 통제를 시행하고, 개인정보 보호를 위한 보안 소프트웨어를 사용하며, 관련 법령에 따라 정기적으로 보안 점검을 실시합니다.
      </p>
    </div>

    <div class="mb-4">
      <h3>제8조 (이용자의 권리)</h3>
      <p>
        회사는 이용자의 개인정보를 직접 수집하거나 저장하지 않으며, 자동으로 수집된 정보는 일정 기간 동안만 보관 후 파기됩니다. 이에 따라 이용자는 개인정보의 조회, 수정, 삭제를 요청할 수 없습니다.
      </p>
    </div>

    <div class="mb-4">
      <h3>제9조 (개인정보 처리방침의 변경)</h3>
      <p>
        회사는 개인정보 처리방침을 변경할 수 있으며, 변경 시 웹사이트에 공지합니다. 변경된 사항은 공지 후 즉시 효력이 발생하며, 중요 변경 사항에 대해서는 별도로 알림을 드릴 수 있습니다.
      </p>
    </div>
    <!--
    <div class="mb-4">
      <h3>제10조 (문의처)</h3>
      <p>
        개인정보 관련 문의나 요청이 있을 경우, 아래의 연락처로 문의 바랍니다.
      </p>
      <p><strong>이메일</strong>: xxx@kimpmoa.com</p>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy"
};
</script>

<style scoped>
.container {
  max-width: 800px;
  text-align: left;
}
h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}
h3 {
  font-size: 1.5rem;
  margin-top: 20px;
}
p {
  font-size: 1rem;
  margin-bottom: 15px;
}
ul {
  margin-left: 20px;
}
</style>
